import {IQueryBuilder} from '@/interfaces/query-builder';

export interface ISearchEngine {
  id?: number;
  form_id: number;
  name: string;
  description?: string;
  query_builder: IQueryBuilder;
  reference_type: SearchEngineReferences;
  reference_key: number;
}


export enum SearchEngineReferences {
  OWN_FORM = 'OWN_FORM',
  OTHER_FORM = 'OTHER_FORM',
  EXTERNAL_DATA = 'EXTERNAL_DATA',
}
